module.exports = __webpack_public_path__ + "static/img/user2.198273c2.png";